import app from 'flarum/forum/app';
import Extend from 'flarum/common/extenders';
import IndexPage from 'flarum/forum/components/IndexPage';
import Discussion from 'flarum/common/models/Discussion';
import DiscussionTaggedPost from './components/DiscussionTaggedPost';
import TagsPage from './components/TagsPage';
import commonExtend from '../common/extend';
import extendDeck from './extendDeck';
export default [...commonExtend, new Extend.Routes() //
.add('tags', '/tags', TagsPage) //
.add('tag', '/t/:tags', IndexPage) //
.helper('tag', tag => app.route('tag', {
  tags: tag.slug()
})), new Extend.PostTypes() //
.add('discussionTagged', DiscussionTaggedPost), new Extend.Model(Discussion) //
.hasMany('tags') //
.attribute('canTag'),
// flarum/deck is an optional dependency, so it has loaded before this runs.
...('flarum-deck' in flarum.extensions ? extendDeck() : [])];